export default {
  nextLang: "العربية",
  banner_message: "For inquiries, please contact us on wecare@posrocket.com",
  catalog: "Catalog",
  categories: "Categories",
  items: "Items",
  combos: "Combos",
  email_address: "Email Address",
  email: "Email",
  enter_email: "Enter email",
  gender: "Gender",
  enter_gender: "Enter gender",
  password: "Password",
  sub_domain: "Business Domain",
  remember_me: "Remember Me",
  reset_password: "Reset Password",
  back_to_login: "Back to login",
  login: "Login",
  invalid_email: "email is a required field",
  invalid_sub_domain: "please fill in the business domain",
  invalid_password: "please fill in the password",
  fill_all_required_fields_message: "Please fill in the required fields",
  form_validation_error: "Form validation error",
  success_reset_title: "Password reset has been requested",
  success_reset_message: "We have sent you a new password to your email!",
  auth_slider_text: "A point-of-sale that helps you sell and grow",
  menu: {
    catalog: "Catalog",
    dashboard: "Dashboard",
    today_orders: "Today's Orders",
    items: "Items",
    reports: "Reports",
    customers: "Customers",
    settings: "Settings",
    business_settings: "Business Settings",
    account_settings: "Account Settings",
    logout: "Log Out",
    orders: "Orders",
    categories: "Categories",
    modifiers_list: "Modifiers List",
    combos: "Combos",
    recipes_book: "Recipes Book",
    history: "Orders History",
    subscription_and_billing: "Subscription & Billing",
    integrations: "Integrations",
    call_center: "Call Center",
    cash_and_payment: "Cash & Payment",
    ooc_dashboard: "Dashboard",
    ooc_login: "OOC Login",
    ooc_integration: "Integration",
    ooc: "OOC App",
    ooc_merchants: "Merchants",
    ooc_orders: "Orders",
    communications: "Communication",
    taxes: "Taxes",
    extra_charge: "Extra charge",
    cc_customers: "Customers",
    cc_dashboard: "Dashboard",
    cc_items: "Items",
    discounts: "Discounts",
    currencies: "Currencies"
  },
  footer: {
    about_us: "About Us",
    email_us: "Email Us",
    switch_lang: "اللغة العربية",
    copy_right_text: "Copyright © {year} POSRocket. All rights Reserved",
  },
  create_customer: "Create Customer",
  edit_customer: "Edit Customer",
  actions: "Actions",
  select_locations: "Select Branch",
  personal_information: "Personal Information",
  additional_details: "Additional Details",
  address_details: "Address Details",
  add_first_primary_address: "Add a first Primary Address",
  no_address_found: "No Address Found",
  primary_address: "Primary Address",
  primary: "Primary",
  make_primary: "Set as primary",
  delete_address: "Delete address",
  add_address: "Add address",
  address_modal_title: "Address details",
  optional_fields: "Optional fields",
  add_address_label_name: "Add label for the address",
  select_city: "Select city",
  select_area: "Select area",
  label: "Label",
  area: "Area",
  city: "City",
  residence: "Residence",
  building_villa: "Building, Villa",
  select_street: "Select street",
  street: "Street",
  enter_floor_number: "Add floor number",
  floor_number: "Floor No.",
  enter_building_number: "Add building number",
  building_number: "Building No.",
  apartment_number: "Apartment No.",
  enter_apartment_number: "Add apartment number",
  back: "Back",
  current_location: "Current location",
  search_on_map: "Search on map",
  primary_fields: "Primary fields",
  first_name: "First name",
  enter_customer_first_name: "Add customer's first name",
  last_name: "Last name",
  enter_customer_last_name: "Add customer's last name",
  date_of_birth: "Date of birth",
  year: "Year",
  month: "Month",
  day: "Day",
  add_another_phone_number: "Add another phone number",
  customer_notes: "Customer's notes",
  add_notes_about_your_customer: "Add notes about this customer",
  tags: "Tags",
  discount_tag_label: "Tag's discount",
  discount_item_label: "Item Auto Discounts",
  tags_auto_complete_test: "Add Tags to categorize things into groups",
  add_another_address: "Add another address",
  save: "Save",
  cancel: "Cancel",
  primary_number: "Primary Number",
  delete_number: "Delete Number",
  source: "Source",
  first_name_required: "First name required",
  last_name_required: "Last name required",
  enter_valid_email: "Enter valid email",
  email_required: "Email address required",
  year_required: "Year required",
  month_required: "Month required",
  day_required: "Day required",
  unspecified: "Unspecified",
  male: "Male",
  female: "Female",
  valid_phone_numbers: "Make sure all phone numbers are valid numbers",
  web_register: "Web Register",
  personal: "Personal",
  default: "Default",
  edit: "Edit",
  manage: "Manage",
  customer_insights: "Customer Insights",
  customer_insights_with_name: "{customer} Insights",
  past_transactions: "Past Transactions",
  timeline: "Timeline",
  wallet: "Wallet",
  transactions: "Transactions",
  transaction: "Transaction",
  report: "Reports",
  favorites: "Favorites",
  loyalty_measure: "Loyalty",
  history: "Previous Orders",
  show: "Show",
  everything: "Everything",
  comments_only: "Comments only",
  transaction_only: "Transaction only",
  item: "Item",
  quantity: "Quantity",
  price: "Price",
  print: "Print",
  edit_address: "Edit address",
  success_copy_message: "Copied successfully!",
  close: "Close",
  updated_successfully: "Data updated successfully!",
  not_updated: "Data not updated yet!",
  leave_changes_message: "You didn't save your changes. Are you sure you want to leave without saving?",
  remove_selected_items_message: "Are you sure to delete the selected rows?",
  leave_changes_title: "Leave Page?",
  leave_title: "Leave",
  add_tag: "Add tag",
  do_not_leave_title: "Keep editing",
  note_have_create_permission_message: "You don't have permission to create",
  created: "Creation Date",
  serial_number: "Serial Number",
  location: "Branch",
  sale_option: "Sale option",
  payment_method: "Payment methods",
  payment_status: "Payment status",
  time_to_end: "Time to end",
  total_amount: "Total amount",
  column: "Column",
  contain: "Contain",
  filter_input_placeholder: "Type in your filter value",
  select_all: "Select all",
  all_locations: "All Branches",
  customer_create_message: "Customer created successfully",
  customer_updated_message: "Customer updated successfully",
  status: "Status",
  search_text_placeholder: "{placeholder}",
  search_on_ticket_number: "Search on ticket number",
  search_orders_placeholder: "Search by customer name, phone #, and order #",
  search_items_placeholder: "Search in items",
  search_customers_placeholder: "Search in customers",
  valid_phone_number: "Valid phone number required",
  primary_phone_number: "Primary Phone Number",
  first_phone_number: "First Phone Number",
  second_phone_number: "Second Phone Number",
  third_phone_number: "Third Phone Number",
  forth_phone_number: "Forth Phone Number",
  fifth_phone_number: "Fifth Phone Number",
  page_count_string: "Rows per page :",
  customer_name: "Customer name",
  customer_phone: "Phone number",
  customer_tags: "Tags",
  last_visit: "Last Visit",
  number_of_orders: "Number of orders",
  amount_spent: "Amount Spent",
  average_spend: "Average Spent/ Order",
  confirm_remove: "Confirm remove!",
  button_delete_title: "Delete selected!",
  customer: "customer",
  no_tags_found_message: "Press enter to add a new tag",
  no_filters_found_message: "No filters applied to this view",
  filters: "Filters",
  add_filters: "Add filter",
  settings_location_link: "Location details",
  settings_devices_link: "Devices",
  settings_order_source_link: "Order source",
  settings_sales_options_link: "Sales options",
  deactivate_device: "Deactivate device",
  settings_drivers_link: "Drivers",
  create_driver: "Create driver",
  create_order_source: "Add order source",
  create_order: "Create Order",
  update_order_with_name: "Update Order ({name})",
  phone_number: "Phone number",
  driver_name: "Driver name",
  teams: "Teams",
  locations: "Branches",
  enter_driver_name: "Add driver name",
  name_required: "Name required",
  name: "Name",
  select_driver_working_team: "Select driver working team",
  create_sales_option: "New sales options",
  create_new_team: "Press Enter to Create new Team",
  enter_order_source_name: "Enter new order source",
  extra_charge: "Extra charge",
  type: "Type",
  add_special_charge_per_location: "Add special charge per branch",
  draft: "Draft",
  queued: "Queued",
  pending: "Pending",
  dismissed: "Dismissed",
  accepted: "Accepted",
  completed: "Completed",
  failed: "Failed",
  in_planet_problem: "Failed",
  canceled: "Canceled",
  rejected: "Rejected",
  last_modified: "Last Modification Date ",
  order_number: "Order Number",
  agent: "Agent",
  customer_number: "Customer Number",
  create_new_customer: "Create new customer",
  search_customer: "Search in customers",
  search_item: "Search in items",
  search_category: "Search in categories",
  select_variation: "Select Variation",
  variations: "Variations",
  small: "Small",
  medium: "Medium",
  large: "Large",
  add_discount: "Add discount",
  add_note: "Add note",
  notes: "Customer Notes",
  add_item_note_placeholder: "Add note for this item",
  select_discount: "Select discount",
  discount: "Discount",
  customer_info: "Customer Information ",
  order_info: "Order Information",
  order_item: "Order item",
  order_items: "Cart",
  delivery: "Delivery",
  select_location: "Select Branch",
  delivery_time: "Order time",
  sales_option: "Sales option",
  charge_with_total: "charge {total}",
  confirm_order: "Order Confirmation",
  not_allowed_order_message: "Editing the order is not allowed",
  building: "Building",
  villa: "Villa",
  select_delivery_time: "Select order time",
  select_location_message: "Select branch first",
  most_popular: "Most Popular",
  customer_favorites: "Customer's Favorites",
  all_categories: "All Categories",
  select_modifier: "Select modifiers",
  modifier: "Modifiers",
  no_items_selected: "Empty cart",
  call_center: "Call Center",
  call_center_orders_history: "Call Center Orders History",
  leave_selected_customer_message_title: "Remove Customer Confirmation ",
  leave_selected_customer_message:
    "Removing the customer will cancel the current order. Are you sure you want to proceed?",
  add_item: "Add item",
  add: "Add",
  item_total: "Item total",
  warning: "Warning",
  message_user_not_selected: "Assign a customer for this order first",
  message_no_items_found: "No items found in {locationName} branch",
  message_already_added: "Item is already added",
  ok: "Ok",
  update: "Update",
  total: "Total",
  delivery_fees: "Delivery Fees",
  auto: "auto",
  upload_image_label: "Upload Photo",
  uploaded_image: "Upload Image",
  edit_image: "Edit Image",
  delete_image_confirmation: "Are you sure you want to remove this image from the category?",
  delete_image_confirmation_title: "Remove Image",
  delete: "Delete",
  open: "Open",
  opened: "Accepted",
  closed: "Completed",
  cancel_create_order_message: "You are about to cancel the current order. Are you sure you want to proceed?",
  cancel_create_order_title: "Cancel Order Confirmation",
  cancel_update_order_title: "Leaving order update ",
  confirm_delete_order_message: "Are you sure you want to cancel this order?",
  confirm_delete_order_title: "Cancel Order Confirmation",
  button_delete_permanently_title: "Cancel order",
  confirm_to_update_order_status_message: "Are you sure you want to resend this order?",
  confirm_to_update_order_status_title: "Updating order status",
  confirm_to_update_order_status_action_title: "Ok",
  partially_refunded: "Partially Refunded",
  partially_paid: "Partially Paid",
  voided: "Voided",
  paid: "Paid",
  includes: "Includes",
  excludes: "Excludes",
  is_a: "Is a",
  contains: "Contains",
  is_not_a: "Is not a",
  is_more_than: "Is more than",
  is_less_than: "Is less than",
  equals: "Equals",
  calculate_tab: "Calculate order",
  tax: "Tax",
  taxes: "Taxes",
  create_tab_button_title: "Dispatch",
  create_tab_button_draft_title: "Save as a draft",
  additional_comment: "Additional Notes",
  additional_comment_placeholder: "Additional Notes",
  order_created_success_message: "Order Dispatch Successfully",
  order_created_failed_message: "Order could not be dispatched",
  order_saved_success_message: "Order is successfully saved as draft",
  order_saved_error_message: "Order is not saved as a draft yet",
  clear_basket_link_title: "Clear cart",
  clear_order_basket_message: "You are about to remove all items from this cart. Are you sure you want to proceed?",
  clear_order_basket_title: "Clear Cart Confirmation ",
  clear_button_text: "Confirm",
  cancel_button_text: "Cancel",
  favorite_order_option: "Favorite Sale Option",
  favorite_product: "Favorite Product",
  account_receivable: "Account Receivables",
  average_bill: "Average order",
  ave_bill: "Avg. Order",
  average_basket_size: "Average basket size",
  most_used_payment: "Most used payment method",
  total_money_spent: "Total money spent",
  discount_total: "Discounts total",
  discount_name: "Discount Name",
  discount_details: "Discount Details",
  total_items_count: "Total items bought",
  number_of_visits: "Number of visits",
  apply: "Apply",
  created_at: "Created",
  updated_at: "Modified at",
  save_edit: "Save Edit",
  last_transaction: "Last transaction",
  last_dine_in: "Last dine-in",
  last_delivery: "Last delivery",
  create_new_category: "Create New Category",
  local_name: "Local Name",
  display_name: "Display Name",
  category_taxes: "Category Taxes",
  select_category_taxes: "Select Category Taxes",
  enter_item_name: "Enter Item Name",
  enter_item_local_name: "Enter Item Local Name",
  category_name_required: "Category Name Required",
  category_create_message: "Category Created Successfully",
  category_updated_message: "Category Updated Successfully",
  category: "Category",
  assign_items_title: "Assign Items to {categoryName} ",
  item_reassign_message: "Items in the other categories will be reassigned to this one",
  item_reassign_message_sec: " will be assigned to the {categoryName} category",
  item_remove_message_title: "Remove item from {categoryName} ",
  item_remove_message:
    "This action will remove the item {itemName} from {categoryName} category. The item will have no category assigned",
  remove: "Remove",
  assigned_items: "Assigned Items",
  all_assigned_items: "All Assigned Items",
  date: "Date",
  time: "Time",
  order_option: "Sale Option",
  net_sale: "Net Sales",
  remaining_balance: "Remaining Balance",
  sold_by: "Sold By",
  last_updated: "Last Updated",
  total_collected: "Total Collected",
  extra_charges: "Extra Charges",
  refunds: "Refunds",
  discounts: "Discounts",
  failed_card_title: "Sending to Branch",
  amount: "Amount",
  end: "End",
  start: "Start",
  validity: "Validity",
  days: "Days",
  rate: "Rate",
  pending_status_tooltip_message: "Order not accepted or rejected by branch yet",
  rejected_status_tooltip_message: "Order rejected by branch before acceptance",
  canceled_status_tooltip_message: "Order cancelled from pending or after branch acceptance",
  failed_status_tooltip_message: "Could not send order to branch ",
  all_statuses: "All Statuses",
  my_orders: "My Orders",
  all_orders: "All Orders",
  no_status_selected_message: "No Status Selected",
  image_preview: "image-preview",
  locations_search_placeholder: "Search by branch",
  cities_search_placeholder: "Search by city",
  no_locations: "No Branches",
  tooltip_re_pending_status: "update status to pending",
  currency_management: "Currency Management",
  payment_processors: "Payment Processors",
  payment_methods: "Payment Methods",
  payment_method_placeholder: "Select payment method",
  void_reasons: "Void Reasons",
  pay_in_out: "Pay In/Out",
  create_extra_charges: "Create Extra Charges",
  create_extra_charge: "Create Extra Charge",
  select_tax: "Select Tax",
  applied_to: "Applied To",
  select_order_options: "Select Sale Option",
  tax_name: "Tax Name",
  extra_charge_name: "Extra Charge Name",
  fixed: "Fixed",
  percentage: "Percentage",
  select_all_locations: "Select All Branches",
  edit_extra_charge: "Edit Extra Charge",
  deleting_extra_charge_title: "Deleting Extra Charge",
  delete_extra_charge: "Delete Extra Charge",
  delete_extra_charge_success: "Extra Charge Deleted Successfully",
  create_extra_charge_success: "Extra Charge Created Successfully",
  update_extra_charge_success: "Extra Charge Updated Successfully",
  tax_required: "Tax is required",
  rate_required: "Rate is required",
  valid_rate_required: "Only 4 digits accepted",
  location_required: "Branch required",
  apply_changes: "Apply",
  edit_extra_charge_message:
    "You are changing the values of the extra charge {extraChargeName}\n  This change is critical and will be affecting the way the reports are calculated.\n  This action can’t be undone, are you sure you want to proceed?",
  tooltip_cancel_order: "update status to canceled",
  tooltip_edit_order: "edit order details",
  tooltip_open_transaction_details: "open transaction details ",
  tooltip_open_tags: "show tags",
  tooltip_my_orders: "show my orders",
  tooltip_all_orders: "show all orders",
  tooltip_edit_customer: "edit customer",
  tooltip_open_insights: "open insights",
  tooltip_item_details: "edit order details",
  tooltip_basket_remove_item: "remove item from basket ",
  tooltip_empty_basket: "reset basket list",
  tooltip_open_discount_details: "show discount details",
  enter_item_price: "Item price",
  assign_tax: "Assign Tax",
  assign_tax_message: "extra charges will have {tax_name} tax",
  confirm: "Confirm",
  others: "others",
  search_on_taxes_placeholder: "Search in taxes",
  address_label_with_index: "Address {index}",
  selected_locations_with_count: "{count} branches",
  item_note: "Item Note",
  delete_customers_success: "Customers deleted successfully",
  data_not_saved_yet: "Data not saved yet",
  create_new_customer_hint: "Press enter to create a new customer",
  of: "of",
  tooltip_order_details: "Order details",
  order_details_ooc: "{orderName} Order details",
  adding_discount_confirm_title: "Adding Discount",
  adding_discount_confirm_message: "Adding this discount will override discounts per items. Do you want to proceed?",
  override_auto_discount_confirm_message:
    "Adding this discount will override automatic discounts. Do you want to proceed?",
  yes: "Yes",
  message_no_transactions: "This customer has no past transactions",
  order_with_name: "Order ({name})",
  adding_discount_override_confirm_message:
    "Adding this discount will override automatic discounts. Do you want to proceed?",
  last_order: "Last Order",
  more_insights: "More Insights",
  select_agent: "Select Agent",
  agents_search_placeholder: "Search by agent name",
  no_agents: "No Agents",
  call_center_edit_order: "Call Center Edit Order",
  tooltip_reorder: "Re-Order",
  reorder: "Re-order",
  customer_details: "Customer details",
  unlimited: "Unlimited",
  Open: "Open",
  Busy: "Busy",
  Closed: "Closed",
  avenue: "Avenue",
  block: "Block",
  select_avenue: "Select Avenue",
  select_block: "Select Block",
  no_internet_message: "No internet connection",
  internet_back_message: "Internet connected",
  available_locations: "Available Branches",
  default_location: "Default Branch",
  set_empty_area_default: "Set Empty Area Default",
  edit_available_branch: "Edit available branch",
  edit_default_branch: "Edit default branch",
  set_available_branches: "Set Available Branches",
  selected_areas_with_number: "{areas} areas selected",
  selected_branches_with_number: "{branches} branches",
  selected_areas_description:
    "<b>{areasCount} areas selected</b>  will have the branches below available when creating an order in the call center",
  selected_area_description:
    "<b>{areasName}</b>  area will have the branches below available when creating an order in the call center",
  selected_branches_available_description: "will be set as available branches",
  edit_available_branches_area: "Edit available branches for area",
  selected_branch_areas_description:
    "{branchName} area will have the branches below available when creating an order in the call center",
  set_branches_number: "Set {number} Branches",
  total_bill: "Total Bill",
  any_item: "Any Item",
  specific_category: "Specific Category",
  specific_item: "Specific Item",
  edit_default_branch_modal_title: "Edit default branch for area",
  edit_default_branch_areas_modal_title: "Edit default branch for multiple areas",
  default_branch_area_modal_description:
    "<b>{areaName} </b>will have the below default branch when creating an order in the call center",
  default_branch_areas_modal_description:
    "<b>{number} </b>areas will have the below default branch when creating an order in the call center",
  default_branch_area_modal_disclaimer:
    "The selected default branch will be default only for the areas that have this branch as an available branch",
  edit_empty_areas_modal_title: "Set empty area default branch",
  edit_empty_areas_modal_message:
    "Branch selected below will be the business default branch. This branch will be added as a default when creating orders in the call center for customers without an address",
  label_required: "Label required",
  city_required: "City required",
  area_required: "Area required",
  avenue_required: "Avenue required",
  block_required: "Block required",
  residence_required: "Residence required",
  datetime_error_title: "Invalid Selected Time",
  datetime_error_message: "Time selected is in the past, make sure to select a time later than the current time",
  datetime_error_button_title: "Ok",
  extra_info: "Extra Info",
  confirm_delivery_fees_error_title: "Invalid delivery fees amount",
  confirm_delivery_fees_error_message: "Please check the delivery fees amount value",
  confirm_delivery_fees_button_title: "Set Delivery Fees",
  tax_exc: "Additive Tax",
  tax_inc: "Inclusive Tax",
  delivery_note: "Delivery Notes",
  delivery_note_hint: "These notes will be printed on the driver receipt",
  all_week: "All Week",
  access_denied_title: "Access Denied",
  access_denied_message: "Sorry, you do not have the permission to access the requested page",
  get_support_message: "If you require assistance please contact",
  customer_support: "Customer Support",
  change_location_message: "Change Branch Confirmation ",
  change_location_title: "Changing the branch will reset this order. Are you sure you want to proceed?",
  empty_state_order: "No history orders available for this customer",
  saved_successfully: "Saved Successfully",
  something_went_wrong: "Something went wrong",
  business_name: "Business Name",
  customer_id: "Customer ID",
  country: "Country",
  integrations: "Integrations",
  select_integrations_to_edit_the_menu: "Select integrations to edit the menu",
  edit_menu_for: "Edit menu for",
  menus: "Menus",
  number_of_items: "No. of items",
  number_of_integrations: "No. of integrations",
  last_updated_by: "Last updated by",
  add_menu: "Add Menu",
  days_ago: "days ago",
  menus_integration: "Menus integrations",
  no_data: "No data found",
  no_orders_yet: "No orders found",
  type_your_message: "Type Your Message",
  session_timeout: "Session TimeOut",
  driver_phone: "Driver Phone Number",
  delete_customer: "Delete Customer",
  delete_customers: "Delete Customers",
  CALLCENTER: "Call Center",
  REGISTER: "Register",
  DASHBOARD: "Dashboard",
  TALABAT: "Talabat",
  refresh_merchants: "Refresh Merchants",
  manage_menu: "Manage Menus",
  Select_branch_to_edit_its_menus: "Select branch to edit its menus",
  menu_name: "Menu Name",
  available_items: "Available Items",
  active_integrations: "Active Integrations",
  no_menus_yet: "No menus created for this branch yet",
  menu_integrations: "Menu Integrations",
  delete_menu: "Delete Menu",
  deleting_menu_for: "Deleting Menu for",
  merchant_menu_confirmation_delete_message: "Are you sure you want to proceed with deleting <b> {name} </b> ?",
  merchant_menu_confirmation_delete_title: "Deleting Menu for {branch} ",
  delete_confirmation: "Are you sure you want to proceed with deleting",
  question_mark: "?",
  menu_label: "Menu",
  integration_name: "Integration Name",
  manage_menu_integrations: "Manage Menu Integrations",
  next: "Next",
  enable_all: "Enable all",
  cancel_menu_creation: "Cancel Menu Creation ",
  you_will_lose_edits:
    "You are about to cancel the menu you are creating, all items added to this menu will be lost. Are you sure you want to cancel?",
  not_enabled_branch:
    "This branch is not enabled on any of the integrations. Please update the integration settings for this merchant first",
  basic_information: "Basic Information",
  edit_variation: "Edit Variation",
  edit_modifier: "Edit Modifier",
  original_name: "Original Name",
  original_local_name: "  Original local Name",
  item_description: "Item Description",
  item_local_description: "Item Local Description",
  variation_name: "Variation Name",
  variation_local_name: "Variation local name",
  variation_price: "Variation Price",
  original_variation_price: "original variation price",
  list_name: "List name",
  list_local_name: "List Local Name",
  original_price: "Original Price",
  add_menu_for: "Add menu for",
  removing_category_from_menu: "Removing Category from Menu",
  removing_category_body:
    "You are about to remove the category {category_name} from your menu. <br> <br> Removing this category will lose all the modifications done on it or its items. Do you want to proceed?",
  remove_category: "Removing Category from Menu",
  modifier_lists: "Modifiers Lists",
  save_item: "Save Item",
  save_variation: "Save Variation",
  save_modifiers_list: "Save Modifiers List",
  quantity_allowed: "Quantity allowed",
  business_id: "Business ID",
  modifiers_lists: "Modifiers Lists",
  search_menus: "Search Menus",
  custom_menus_list: "Custom Menus List",
  main_menu: "Main Menu",
  original_categories: "Original Categories",
  leaving_edit_menu: "Leaving Edit Menu",
  leaving_edit_menu_message:
    "You are about to leave the editing for the menu  <b>{menuName}</b>. <br><br> You will be losing all your changes. Are you sure you want to leave?",
  search_area: "Search for area",
  search_customer_placeholder: "Search on customer name or phone number",
  confirm_accept: "Confirm",
  category_name: "Category Name",
  category_local_name: "Category Local Name",
  no_available_items: "No. of available items",
  item_name: "Item Name",
  item_local_name: "Item Local Name",
  modifier_name: "Modifier Name",
  modifier_local_name: "Modifier Local Name",
  business_branch_menu: "{business_name} {branch_name} Menu",
  no_modifiers_lists_available: "No Modifiers lists available for this item",
  modifiers: "Modifiers",
  single_option: "  Single option",
  multiple_options: "  Multiple options",
  note: "Note",
  orders_list: "Orders List",
  order_id: "Order ID",
  location_id: "Location ID",
  created_at_label: "Creation Date",
  location_name: "Location Name",
  order_name: "Order Name",
  chat_empty_state: "Select a branch to begin a chat",
  search_orders: "Search Orders",
  merchants_list: "Merchants List",
  undefined_source: "Unknown Source",
  selected_with_count: "{count} Selected",
  confirm_delete_customer_message: "You are about to delete {countTitle}. Are you sure you want to proceed?",
  customers: "customers",
  search_original_categories: "Search Original Categories",
  order_log: "{orderName} Order Log",
  order_log_menu: " Order Log",
  log_timeline: "Order Timeline",
  no: "No",
  creation_time: "Creation Time",
  delete_customer_message: "You are about to delete this customer. Are you sure you want to proceed? ",
  delete_customer_title: "Delete Customer",
  add_custom_amount: "Add custom amount ",
  add_custom_item: "Add Custom Item",
  custom_amount_item: "Custom amount item",
  custom_item_name: "Custom Item Name",
  submit: "Submit",
  order_custom_item: "Custom Item Name",
  extra_charge_price: "Extra charge price",
  custom: "Custom",
  validate_custom_item_price: "Price Required",
  validate_custom_item_name: "Name required",
  edit_custom_item: "Edit Custom Item",
  parsed: "Queued",
  to: "to",
  edit_tax_message:
    "You are changing the values of the tax {taxName}.\n  This change is critical and will be affecting the way the tax is calculated in all items that are linked to it and in reports.\n  This action can’t be undone, are you sure you want to proceed?",
  delete_tax_success: "Tax Deleted Successfully",
  create_tax_success: "Tax Created Successfully",
  update_tax_success: "Tax Updated Successfully",
  deleting_tax_title: "Delete Tax",
  delete_tax_message:
    "You are about to delete the tax {taxName}.\n This change is critical and will be affecting all items that are linked to this tax and all reports.\n  This action can’t be undone, are you sure you want to proceed?",
  delete_tax: "Delete Tax",
  create_tax: "Create Tax",
  tax_type: "Tax Type",
  additive: "Additive",
  inclusive: "Inclusive",
  select_tax_type: "Select Tax Type",
  add_tax: "Add Tax",
  tax_type_required: "Tax type is required",
  invalid: "Invalid",
  business_details: "Business Details",
  settings_business_details_link: "Business Details",
  edit_business_details: "Edit Business Details",
  address: "Address",
  business_contact_email: "Business Email",
  sender_email: "Sender Email",
  time_zone: "Time Zone",
  business_currency: "Business Currency",
  end_of_business_day: "End of business day",
  rocket_uses_this_email: "POSRocket uses this email to contact your business!",
  customers_use_this_email: "Your business contact your customers using this email!",
  enter_address: "Enter Address",
  industry: "Industry",
  confirm_leave_edit_business_message: "Are you sure you want to leave without saving the business details?",
  confirm_leave_edit_business_title: "Cancel Edits",
  business_name_setting: "Business Name",
  search_driver_placeholder: "Search for driver name or phone number",
  add_driver: "Add New Driver",
  edit_driver: "Edit Driver",
  delete_driver: "Delete Driver",
  edit_teams: "Edit Teams",
  driver_create_leave_message: "Are you sure you want to leave without adding the new driver?",
  driver_edit_leave_message: "Are you sure you want to leave without saving this driver?",
  driver_edit_leave_title: "Cancel Edits",
  driver_create_leave_title: "Unsaved Driver",
  delete_confirmation_title: "Delete Confirmation",
  delete_driver_message: "You are about to delete 1 driver. Are you sure you want to proceed?",
  end_of_business_day_required: "End of business day required",
  unselected_date_time: "Unscheduled",
  service_charge: "Service Charge",
  OOCDelivery: "Delivery",
  view_more: "View more",
  number_of_enabled_items: "No. of Enabled Items",
  top_selling_items: "Top selling items",
  top_selling_areas: "Top selling areas",
  top_selling_agents: "Top selling agents",
  orders_by_location: "Orders by branch",
  total_orders: "Total Orders",
  average_net_sales_per_order: "Average Net Sales/Order",
  total_net_sales: "Total Net Sales",
  average_order_time: "Average Order Time",
  orders_per_day_per_status: "Orders Per Day Per Status",
  order_with_number: "{number} Order",
  order_with_numbers: "{number} Orders",
  average_minute_with_number: "Avg, {number} min",
  minute_with_number: "{number} min",
  quickest_serving_locations: "Quickest serving branches ",
  months: "months",
  days_name: "days",
  month_name: "month",
  previous: "Previous",
  welcome_user_name: "Welcome, {username}",
  coming_soon: "Coming Soon",
  search_driver_by_name: "Search for driver name",
  no_messages: "No messages yet",
  enter_rate: "Enter Rate",
  rate_validation: "Rate required",
  tax_create_leave_message: "Are you sure you want to leave without adding the new tax?",
  tax_create_leave_title: "Unsaved Tax",
  tax_edit_leave_message: "Are you sure you want to leave without saving this tax?",
  tax_edit_leave_title: "Cancel Edits",
  rate_limit: "rate must be between 0 and 100",
  amount_validation: "amount must be between 0 and 9999999999999999",
  rate_integer: "rate must be an integer",
  customer_primary_address_title: "Primary Address",
  settings_units_link: "Units",
  add_unit: "Add Unit",
  add_new_unit: "Add New Unit",
  enter_unit_name: "Enter Unit Name",
  abbreviation: "Abbreviation",
  abbreviation_required: "Abbreviation Required",
  enter_unit_abbreviation: "Enter Unit Abbreviation",
  unable_delete_unit: "Unit cannot be deleted because it is currently used in the system",
  edit_unit: "Edit Unit",
  delete_unit_message: "Are you sure you want to delete this unit?",
  unit_create_leave_message: "Are you sure you want to leave without adding the new unit?",
  unit_edit_leave_message: "Are you sure you want to leave without saving this unit?",
  unit_edit_leave_title: "Cancel Edits",
  unit_create_leave_title: "Unsaved Unit",
  add_sale_option: "Add new sales option",
  sale_option_placeholder: "Search by sales option name",
  sale_option_name: "Sales Option Name",
  other: "Other",
  dine_in: "Dine In",
  pick_up: "Pick up",
  create_new_extra_charge: "Press enter to create new extra charge ",
  special_extra_charges_per_location: "special extra charge per location",
  search_by_sales_option_name: "Search by sales option name",
  extra_charge_for_branch: "Extra Charges for {name}",
  delete_order_option_message: "You are about to delete a sales option. Are you sure you want to proceed?",
  leave_create_sales_option_message: "Are you sure you want to leave without saving this sales option?",
  leave_edit_sales_option_message: "Are you sure you want to leave without saving the edits on this sales option?",
  enter_sales_option_name: "Enter Sales Option Name",
  type_required: "Type required",
  edit_sales_option: "Edit Sales Option ",
  new_sale_option: "New Sales Option",
  create_sales_option_title: "Create Sales Option",
  price_validation: "Price required",
  edit_tax: "Edit Tax",
  tax_number: "Tax Number",
  branch_location: "Location",
  branch_name: "Branch Name",
  amount_required: "Amount Required",
  search_on_extra_charges_placeholder: "Search in Extra Charges",
  custom_variation_price_required: "Variation price required",
  customer_address_required: "Customer address is required",
  no_address_selected: "No Address",
  delete_sales_option: "Delete sales option",
  leave__create_sales_option_title: "Unsaved Sales Option",
  leave__edit_sales_option_title: "Cancel Edits",
  create_new_discount: "Add new discount",
  delete_discount_confirm_title: "Are you sure to delete discount!",
  delete_discount_confirm_message: "The discount will be deleted permanently",
  delete_discount_success_success: "The discount deleted successfully!",
  select_type: "Select Type",
  discount_amount: "Discount Amount",
  discount_automatic: "Apply discount automatically",
  discount_after_tax: "Apply discount after tax",
  discount_custom: "Set Custom Amount on iPad Register",
  ANY_ITEM: "Any item",
  TOTAL_BILL: "Total bill",
  SPECIFIC_CATEGORY: "Specific category",
  SPECIFIC_ITEM: "Specific item",
  schedule_discount: "Schedule Discount",
  date_range: "Date Range",
  specific_days: "Specific days of the week",
  SUNDAY: "Sunday",
  MONDAY: "Monday",
  TUESDAY: "Tuesday",
  WEDNESDAY: "Wednesday",
  THURSDAY: "Thursday",
  FRIDAY: "Friday",
  SATURDAY: "Saturday",
  schedule_discount_text: "Schedule this discount to be valid for specific date range or days.",
  discount_type_required: "Type is required",
  create_discount_success: "Discount Created Successfully",
  applied_required: "Applied to is required",
  edit_discount: "Edit discount",
  automatic: "Automatic",
  not_automatic: "Not Automatic",
  search_categories_placeholder: "Search on Categories",
  discount_color: "Discount Color",
  update_discount_success: "Discount Edited Successfully",
  category_required: "Category required",
  item_required: "Item required",
  search_for_city_label: "Search for city",
  search_for_area_label: "Search for area",
  search_for_avenue_label: "Search for avenue",
  search_for_block_label: "Search for block",
  delete_extra_charge_message:
    "You are about to delete one extra charge. Deleting the extra charge will be affecting the sales option as it will have no extra charge assigned to it.  Are you sure you want to proceed?",
  extra_charge_create_title: "Unsaved Extra Charge",
  extra_charge_create_message: "Are you sure you want to leave without adding the new extra charge?",
  extra_charge_edit_title: "Cancel Edits",
  extra_charge_edit_message: "Are you sure you want to leave without saving this extra charge?",
  set_custom_item_tax: "Set Custom Item Tax",
  tax_custom_leave_message: "Are you sure you want to leave without saving the tax for custom items?",
  is: "Is",
  search: "Search",
  add_to_team: "Add to team",
  remove_from_team: "Remove from team",
  add_to_branch: "Add to branch",
  remove_from_branch: "Remove from branch",
  enable: "Enable",
  disable: "Disable",
  delete_drivers_message: "You are about to delete {count} driver. Are you sure you want to proceed?",
  discount_rate: "Discount Rate",
  validate_number_value: "Valid Number required in Discount Amount",
  validate_percent_number_value: "Discount rate required to be between 0 and 100",
  delete_order_option_message_secondary:
    "You are about to delete a sales option. Do you want to delete this sales option from the business or only remove it from the selected branches?",
  remove_from_branches: "Remove from Branches",
  total_orders_increase_tooltip:
    "Total Orders from {startDate} to {endDate} \n increased by {amount} compared to the previous period.",
  total_orders_decrease_tooltip:
    "Total Orders from {startDate} to {endDate} \n decreased by {amount} compared to the previous period.",
  avg_net_sale_increase_tooltip:
    "Average Net Sales/Order from {startDate} to {endDate} \n increased by {amount} compared to the previous period.",
  avg_net_sale_decrease_tooltip:
    "Average Net Sales/Order from {startDate} to {endDate} \n decreased by {amount} compared to the previous period.",
  total_net_sale_increase_tooltip:
    "Total Net Sales from {startDate} to {endDate} \n increased by {amount} compared to the previous period.",
  total_net_sale_decrease_tooltip:
    "Total Net Sales from {startDate} to {endDate} \n decreased by {amount} compared to the previous period.",
  average_order_time_increase_tooltip:
    "Average Order Time from {startDate} to {endDate} \n increased by {amount} compared to the previous period.",
  average_order_time_decrease_tooltip:
    "Average Order Time from {startDate} to {endDate} \n decreased by {amount} compared to the previous period.",
  no_customers_found: "No Customers Found",
  no_areas_found: "No Areas Found",
  no_drivers_found: "No Drivers Found",
  no_taxes_found: "No Taxes Found",
  no_discounts_found: "No Discounts Found",
  no_extra_charges_found: "No Extra Charges Found",
  add_to_team_message: "Please select the teams you want to assign the {count} selected drivers to",
  remove_from_team_message: "Please select the teams you want to remove the {count} selected drivers from",
  add_to_branch_message: "Please select the branches you want to assign the {count} selected drivers to",
  remove_from_branch_message: "Please select the branches you want to remove the {count} selected drivers from",
  enable_drivers_title: "Enable Confirmation",
  enable_drivers_message: "You are about to enable {count} drivers. Are you sure you want to proceed?",
  disable_drivers_title: "Disable Confirmation",
  disable_drivers_message: "You are about to disable {count} drivers. Are you sure you want to proceed?",
  enable_driver_message: "You are about to enable {count} driver. Are you sure you want to proceed?",
  disable_driver_message: "You are about to disable {count} driver. Are you sure you want to proceed?",
  no_of_drivers: "Number of Drivers",
  team_name: "Team Name",
  enter_team_name: "Enter Team Name",
  delete_team: "Delete Team",
  delete_team_message:
    "You are about to delete a team with linked drivers. Deleting this team will remove the team from the drivers, are you sure you want to proceed?",
  leave_edit_message: "Are you sure you want to leave without saving the edit on the driver teams?",
  digital_menu: {
    title: "Digital Menu",
    create_digital_menu: "Create digital menu",
    edit_digital_menu: "Edit digital menu",
    basic_info: "Basic information",
    header: "Header",
    footer: "Footer",
    business_name: "Business name",
    upload_banner: "Upload banner",
    upload_icon: "Upload icon",
    social_media: "Social media",
    facebook_link: "Facebook link",
    instagram_link: "Instagram link",
    phone_number: "Phone number",
    address: "Address",
    enter_address: "Enter address",
    email_address: "Email address",
    enter_email_address: "Enter email address",
    website_link: "Website link",
    enter_website_link: "Enter website link",
    next: "Next",
    design: "Design",
    font_color: "Font and color",
    background_image: "Background image",
    category_name: "Category name",
    item_name: "Item name",
    show_item_img: "Show item image",
    show_local_name: "Show local name",
    modifier_desc: "Modifier and description",
    show_modifiers: "Show modifiers",
    show_item_desc: "Show item description",
    qr_code: "QR code",
    qr_code_customization: "QR code customization",
    background_color: "Background color",
    text_field: "Text",
    qr_code_color: "QR code color",
    share_menu: "Share your menu",
    download_qr_code: "Download QR code",
    copy_link: "Copy link",
    save: "Save",
    font_family: "Font family",
    font_size: "Font size",
    delete_title: "Delete Digital Menu",
    delete_message: "You are about to delete the digital menu for this branch. Are you sure you want to proceed?",
    deleted_successfully: "Digital menu has been deleted successfully",
    scan_placeholder_text: "Scan to view the menu",
    leave_changes_message: "You didn't save your changes. Are you sure you want to leave without continue?",
  },
  receipt_footer: "Receipt Footer",
  no_receipt_footer: "No Receipt Footer",
  location_type: "Location Type",
  working_days: "Workings Days",
  enter_valid_url: "Enter valid URL",
  amount_rate: "Amount/Rate",
  active:"Active",
  in_active:"Inactive",
  exchange_create_leave_message: "Are you sure you want to leave without adding the new currency?",
  exchange_create_leave_title: "Unsaved currency",
  exchange_edit_leave_message: "Are you sure you want to leave without saving this currency?",
  exchange_edit_leave_title: "Cancel Edits",
  edit_exchange: "Edit Currency",
  add_exchange: "Add Currency",
  edit_exchange_message: "Are you sure you want to leave without saving this currency?",
  create_exchange_success: "Currency Created Successfully",
  update_exchange_success:  "Currency Updated Successfully",
  delete_exchange_message: "You are about to delete the currency. Are you sure you want to proceed?",
  deleting_exchange_title: "Delete Currency",
  delete_exchange: "Delete Currency",
  delete_exchange_success: "Currency Deleted Successfully",
  add_new_exchange: "Add New Currency",
  currency: "Currency",
  conversion_rate: "Conversion Rate",
  inverse: "Inverse",
  currency_required: "Currency required",
  conversion_rate_required: "Convertion rate required",
  inverse_required: "Inverse required",
  advance_filter_clear: "Clear",
  filter: "Filter",
  apply_filter: "Apply Filter",
  clear_filter: "Clear Filter",
  enter_value: "Enter Value",
  driver_deleted: "Driver deleted successfully",
  drivers_deleted: "{count} Drivers deleted successfully",
  driver_created_success: "Driver created successfully",
  driver_edit_success: "Driver edited successfully",
  driver_exist: "Driver already exists",
  add_payment_category: 'Create Pay In/Out Category',
  edit_payment_category: 'Edit Pay In/Out Category',
  category_type: "Category Type",
  locations_label: "Locations",
  payment_category_create_leave_message: "Are you sure you want to leave without adding the new payment category?",
  payment_category_create_leave_title: "Unsaved Payment Category",
  payment_category_edit_leave_message: "Are you sure you want to leave without saving this payment category?",
  payment_category_edit_leave_title: "Cancel Edits",
  unable_delete_payment_category: "Payment category cannot be deleted because it is currently used in the system",
  delete_payment_category_message: "Are you sure you want to delete this payment category?",
  add_new_payment_category: "Add new category",
  search_by_payment_category_name: "Search by category name",
  in: "In",
  out: "Out",
  delete_payment_category_success: "Payment category deleted successfully",
  order_status: {
    DRAFT: "Draft",
    REJECTED: "Rejected",
    PENDING: "Pending",
    CANCELED: "Canceled",
    CLOSED: "Completed",
    OPENED: "Opened",
  },
  the_tax: "Tax",
  set_custom_tax_successfully: "custom tax updated successfully",
  change_tax_message:
    "You are changing the values of the tax {tax_name}<br> <br>This change is critical and will be affecting the way the tax is calculated in all items that are linked to it and in reports.<br> <br>This action can’t be undone, are you sure you want to proceed?",
};
